import React from 'react'
import withIconStyles from '@edulastic/icons/src/HOC/withIconStyles'
import SVG from '@edulastic/icons/src/common/SVG'

const IconGraphLineCut = (props) => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="23.813"
    height="21.159"
    viewBox="0 0 23.813 21.159"
    {...props}
  >
    <g transform="translate(-5745.094 -178.402)">
      <g transform="translate(5745.093 149.878)">
        <g transform="translate(0.001 28.524)">
          <g transform="translate(0 0)">
            <path
              d="M23.813,32.186a3.507,3.507,0,0,0-4.86-.885l-8.081,5.658L7.934,34.9a4.249,4.249,0,1,0-1.788,1.682l3.6,2.52-3.6,2.52A4.254,4.254,0,1,0,7.934,43.3l2.939-2.058,8.081,5.658a3.507,3.507,0,0,0,4.86-.885L13.934,39.1Zm-19.551,2.8a2.2,2.2,0,1,1,2.2-2.2A2.2,2.2,0,0,1,4.262,34.989Zm0,12.637a2.2,2.2,0,1,1,2.2-2.2A2.2,2.2,0,0,1,4.262,47.626Z"
              transform="translate(-0.001 -28.524)"
            />
          </g>
        </g>
        <g transform="translate(17.047 38.516)">
          <g transform="translate(0 0)">
            <rect width="2.057" height="1.469" />
          </g>
        </g>
        <g transform="translate(20.573 38.516)">
          <g transform="translate(0 0)">
            <rect width="2.057" height="1.469" />
          </g>
        </g>
      </g>
    </g>
  </SVG>
)

export default withIconStyles(IconGraphLineCut)
